import { GlSprintf, GlAlert, GlLink } from '@gitlab/ui';
import { DELETE_ALERT_TITLE, DELETE_ALERT_LINK_TEXT } from '../../constants/index';
export default {
    name: 'PartialCleanupAlert',
    components: {
        GlSprintf,
        GlAlert,
        GlLink
    },
    props: {
        runCleanupPoliciesHelpPagePath: {
            type: String,
            required: false,
            default: ''
        },
        cleanupPoliciesHelpPagePath: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'dismiss'
    ],
    i18n: {
        DELETE_ALERT_TITLE,
        DELETE_ALERT_LINK_TEXT
    }
};
